import { Button, Row } from "antd";
import { useCallback, useMemo } from "react";
import { usePermissions } from "../../../../../../../lib/hooks/usePermissions";

type FormFooterButtonsProps = {
  isDisabled: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: () => void;
};

export const FormFooterButtons = ({
  isDisabled,
  setIsOpen,
  onSave,
}: FormFooterButtonsProps) => {
  const onCancel = useCallback((): void => setIsOpen(false), [setIsOpen]);

  const { hasAccessByController } = usePermissions("Contracts");

  const isCloseDisabled: boolean = useMemo(() => {
    if (hasAccessByController("ModifyMailing")) {
      return isDisabled;
    }

    return false;
  }, [hasAccessByController, isDisabled]);

  return (
    <Row className="default-form-buttons w-100 pa-6 divider d-flex position-absolute">
      {hasAccessByController("ModifyMailing") && (
        <Button
          shape="round"
          type="primary"
          onClick={onSave}
          disabled={isDisabled}
          loading={isDisabled}
        >
          Save
        </Button>
      )}
      <Button shape="round" onClick={onCancel} disabled={isCloseDisabled}>
        Cancel
      </Button>
    </Row>
  );
};
